import { useEffect } from "react";
import useSWR from "swr";
import { getChartEvaluationHistory } from "../utils/utils";

export default function useChartEvaluationHistory(symbol, enabled = true) {
  const normalized = String(symbol || "").toUpperCase();
  const result = useSWR(enabled && normalized ? ["chart-evaluation-history", normalized] : null, () =>
    getChartEvaluationHistory(normalized), {
    refreshInterval: 30000,
    revalidateOnFocus: true,
    shouldRetryOnError: false,
  });
  const { mutate } = result;
  useEffect(() => {
    const refresh = () => mutate();
    window.addEventListener("chart_evaluation_saved", refresh);
    return () => window.removeEventListener("chart_evaluation_saved", refresh);
  }, [mutate]);
  return result;
}
